"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.SuggestedLookup = exports.ResultType = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
/**
 * Updated for new UI design (v2)
 * Changes made:
 * 1. Changed the `search-results` popup position to `fixed`.
 * 2. Dynamically updating popup position to align relative to the `searchbar`.
 */
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var ui_common_1 = require("@codametrix/ui-common");
var ui_components_1 = require("@codametrix/ui-components");
var show_results_1 = require("../../transactions/transaction/show-results");
var elements_1 = require("../../../utils/elements");
var conditional_1 = require("../../conditional/conditional");
var result_row_1 = require("./result-row");
var CodeType = ui_common_1.commonEnums.CodeType, SugggestedCodeType = ui_common_1.commonEnums.SugggestedCodeType;
var SUGGESTED_LIST_HEADER_BUTTONS_COUNT = 2;
var ResultType;
(function (ResultType) {
    ResultType["SEARCH_RESULTS"] = "searchResults";
    ResultType["SUGGESTED_RESULTS"] = "suggestedSearchResults";
})(ResultType = exports.ResultType || (exports.ResultType = {}));
var defaultSearchContext = function () { return ({
    codeType: null
}); };
var getSelectionData = function (codeInfo) {
    var _a;
    var searchSelection = {
        code: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.code,
        description: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.description,
        codeType: codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.codeType,
        effectiveDate: '',
        shortDescription: '',
        tenantDefined: false,
        modifierType: (codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.modifierType) || null,
        customCpt: (_a = codeInfo === null || codeInfo === void 0 ? void 0 : codeInfo.customCpt) !== null && _a !== void 0 ? _a : false
    };
    return searchSelection;
};
var placeholderResult = function (text, FieldDefinitions) {
    var styleClasses = ['search-result', 'not-selectable'];
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: (0, classnames_1["default"])(styleClasses) }, { children: [(FieldDefinitions === null || FieldDefinitions === void 0 ? void 0 : FieldDefinitions.length) > 0 && ((0, jsx_runtime_1.jsx)("div", { className: "col-label search-label" })), (0, jsx_runtime_1.jsx)("div", __assign({ className: "col-code-description" }, { children: text }))] })));
};
var suppressEnterKey = function (ev) {
    // in the case of this component being wrapped by a from, for submit,
    // the form looks for the keydown event in order to submit.  For the lookup
    // form we don't want it to trigger a submit at all.
    if (ev.key === 'Enter') {
        ev.preventDefault();
    }
};
var SuggestedLookup = /** @class */ (function (_super) {
    __extends(SuggestedLookup, _super);
    function SuggestedLookup(props) {
        var _this = this;
        var _a, _b;
        _this = _super.call(this, props) || this;
        _this.updatePopupPosition = function () {
            if (!_this.searchRef.current) {
                return;
            }
            else {
                var rect = _this.searchRef.current.getBoundingClientRect();
                var _a = _this.state, resultHeight = _a.resultHeight, resultWidth = _a.resultWidth; // Dynamic popup height
                // Check if search-cols is visible in the viewport
                var isVisible = rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= window.innerHeight &&
                    rect.right <= window.innerWidth;
                if (!isVisible) {
                    // If search-cols is not visible, hide the popup
                    _this.setState({
                        popupPosition: null // Hide popup
                    });
                    return;
                }
                // Calculate available space above and below
                var spaceBelow = window.innerHeight - rect.bottom; // Space below search-cols
                var spaceAbove = rect.top; // Space above search-cols
                var spaceRight = window.innerWidth - rect.left; // Space to the right of the element
                var spaceLeft = window.innerWidth - rect.right; // Space to the left of the element
                // Determine where to show the popup: below or above
                var showBelow = spaceBelow >= resultHeight || spaceBelow >= spaceAbove;
                // Decide horizontal positioning (left or right)
                var showLeft = spaceRight >= resultWidth || spaceLeft >= spaceRight;
                // Calculate top and left positions based on the chosen direction
                var top_1 = showBelow
                    ? rect.bottom // Position below the element
                    : Math.max(0, rect.top - resultHeight); // Position above the element
                var left = showLeft
                    ? rect.left // Position to the left of the element
                    : Math.max(0, rect.right - resultWidth); // Position to the right of the element
                // Update the popup's position
                _this.setState({
                    popupPosition: { top: top_1, left: left }
                });
            }
        };
        _this.handleKeyPress = function (event) {
            var _a, _b, _c, _d;
            switch (event.key) {
                case 'ArrowDown': {
                    // Move focus down in the results
                    event.preventDefault();
                    _this.moveFocus(1); // Pass +1 for downward movement
                    break;
                }
                case 'ArrowUp': {
                    // Move focus up in the results
                    event.preventDefault();
                    _this.moveFocus(-1); // Pass -1 for upward movement
                    break;
                }
                case 'Tab': {
                    var hasSearchResults = ((_b = (_a = _this.props) === null || _a === void 0 ? void 0 : _a.searchResults) === null || _b === void 0 ? void 0 : _b.length) > 0;
                    var suggestedResults = _this.getCurrentSuggestedCodeList();
                    var hasSuggestedResults = ((_c = suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.encounterList) === null || _c === void 0 ? void 0 : _c.length) > 0 ||
                        ((_d = suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.caseList) === null || _d === void 0 ? void 0 : _d.length) > 0;
                    // Only handle custom tab logic if both results exist
                    if (hasSearchResults && hasSuggestedResults) {
                        event.preventDefault();
                        _this.toggleSearchAndSuggested();
                    }
                    else {
                        _this.handleFocusExit();
                    }
                    break;
                }
                case 'ArrowLeft': {
                    // Optionally toggle back to search if suggested results are shown
                    event.preventDefault();
                    _this.toggleSearchAndSuggested(false); // Pass false to toggle back
                    break;
                }
                case 'ArrowRight': {
                    // Optionally toggle back to search if suggested results are shown
                    event.preventDefault();
                    _this.toggleSearchAndSuggested(true); // Pass false to toggle back
                    break;
                }
                case 'Enter': {
                    event.preventDefault();
                    var _e = _this.state, activeSelection = _e.activeSelection, activeIndex_1 = _e.activeIndex;
                    var suggestedResults = _this.getCurrentSuggestedCodeList();
                    var allowHeaderButtons_1 = _this.props.allowCodeRemove;
                    if (activeSelection === ResultType.SUGGESTED_RESULTS) {
                        var caseList = (suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.caseList) || [];
                        var relatedList = (suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.encounterList) || [];
                        var currentOffset_1 = 0;
                        /** Attempts to handle user selection within a given section of suggested codes.
                          * section can be a case list or a related case list.
                        
                          * It handles 3 types of interactions based on the current activeIndex:
                          * 1. Header buttons: "Add All" or "Remove All" (if enabled)
                          * 2. Individual item selection
                          * 3. If nothing matches, it does nothing
                        
                          * Returns true if an action was taken for this section, otherwise false.
                        */
                        var handleSuggestedCodeSection = function (list, type) {
                            if (!list.length)
                                return false;
                            // If header buttons like "Add All" / "Remove All" are shown
                            if (allowHeaderButtons_1) {
                                // "Add All" clicked
                                if (activeIndex_1 === currentOffset_1) {
                                    _this.handleAddAllCodes(event, type);
                                    return true;
                                }
                                // "Remove All" clicked
                                if (activeIndex_1 === currentOffset_1 + 1) {
                                    _this.handleRemoveAllCodes(event, type);
                                    return true;
                                }
                                // Move offset past the header buttons
                                currentOffset_1 += SUGGESTED_LIST_HEADER_BUTTONS_COUNT;
                            }
                            // Check if the activeIndex points to a specific item in this section
                            var itemIndex = activeIndex_1 - currentOffset_1;
                            if (itemIndex >= 0 && itemIndex < list.length) {
                                // Apply the selected code (individual item)
                                _this.applySelectedCode(event);
                                return true;
                            }
                            // Move offset past the items in this section
                            currentOffset_1 += list.length;
                            return false;
                        };
                        if (handleSuggestedCodeSection(caseList.map(function (item) { return item.codeInfo; }), SugggestedCodeType.CURRENT_CASE))
                            break;
                        if (handleSuggestedCodeSection(relatedList.map(function (item) { return item.codeInfo; }), SugggestedCodeType.RELATED_CASE))
                            break;
                    }
                    _this.applySelectedCode(event);
                    break;
                }
                case 'Escape': {
                    _this.handleFocusExit();
                    break;
                }
                default:
                    break;
            }
        };
        /**
         * Handles moving the keyboard focus up or down through a list of results.
         * It determines the active list (search or suggested), calculates the number
         * of focusable rows (including header buttons, if applicable), and updates
         * the active index accordingly. It ensures the new active item is scrolled into view.
         *
         * @param direction - A number indicating the movement direction: -1 for up, +1 for down
         */
        _this.moveFocus = function (direction) {
            var _a, _b, _c, _d, _e, _f, _g;
            var _h = _this.state, activeIndex = _h.activeIndex, activeSelection = _h.activeSelection;
            var searchResults = _this.props.searchResults;
            var suggestedResults = _this.getCurrentSuggestedCodeList();
            var hasSearchResults = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0;
            var hasCaseResults = ((_a = suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.caseList) === null || _a === void 0 ? void 0 : _a.length) > 0;
            var hasEncounterResults = ((_b = suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.encounterList) === null || _b === void 0 ? void 0 : _b.length) > 0;
            // If no active selection is set, initialize it based on available results
            if (activeSelection === undefined || activeSelection === null) {
                if (hasSearchResults) {
                    _this.updateSelection(ResultType.SEARCH_RESULTS);
                    return;
                }
                else if (hasCaseResults || hasEncounterResults) {
                    _this.updateSelection(ResultType.SUGGESTED_RESULTS);
                    return;
                }
            }
            // Total number of items that can receive focus
            var totalRows = 0;
            // Calculate total rows based on the active result type
            if (activeSelection === ResultType.SEARCH_RESULTS) {
                // Only search result items are focusable (no headers here)
                totalRows = (_c = searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) !== null && _c !== void 0 ? _c : 0;
            }
            else if (activeSelection === ResultType.SUGGESTED_RESULTS) {
                // Suggested results can include "Add All" / "Remove All" buttons as well
                var totalCaseRows = hasCaseResults
                    ? (_e = (_d = suggestedResults.caseList) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0
                    : 0;
                var totalEncounterRows = hasEncounterResults
                    ? (_g = (_f = suggestedResults.encounterList) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0
                    : 0;
                // Include header buttons if allowed
                var caseHeaderButtons = hasCaseResults && _this.props.allowCodeRemove
                    ? SUGGESTED_LIST_HEADER_BUTTONS_COUNT
                    : 0;
                var encounterHeaderButtons = hasEncounterResults && _this.props.allowCodeRemove
                    ? SUGGESTED_LIST_HEADER_BUTTONS_COUNT
                    : 0;
                // Final total includes items + headers
                totalRows =
                    totalCaseRows +
                        caseHeaderButtons +
                        totalEncounterRows +
                        encounterHeaderButtons;
            }
            if (totalRows === 0)
                return;
            // Calculate the new active index, wrapping around if needed
            var newIndex = (activeIndex + direction + totalRows) % totalRows;
            // Update the active index, and once the state update is complete,
            // scroll the newly active item into view. The callback ensures scrolling
            // happens *after* React has re-rendered the DOM based on the new index.
            _this.setState({ activeIndex: newIndex }, function () {
                _this.scrollActiveItemIntoView();
            });
        };
        /**
         * Scrolls the currently active item into view within its container
         * (either search results or suggested results), taking into account
         * a fixed header height that may otherwise cover the item.
         */
        _this.scrollActiveItemIntoView = function () {
            // Get the currently active item (the one with a highlight or focus)
            var activeItem = document.querySelector('.search-result-submittable');
            // Height of header or spacing to preserve
            var headerOffset = 60;
            var activeSelection = _this.state.activeSelection;
            // Determine which container to scroll based on which list is currently active
            var container = activeSelection === ResultType.SEARCH_RESULTS
                ? _this.searchResultsRef.current
                : activeSelection === ResultType.SUGGESTED_RESULTS
                    ? _this.suggestedResultsRef.current
                    : null;
            if (!activeItem || !container)
                return;
            // Calculate position of the active item within the container
            var itemTop = activeItem.offsetTop;
            var itemBottom = itemTop + activeItem.offsetHeight;
            var containerTop = container.scrollTop;
            var containerHeight = container.clientHeight;
            var containerBottom = containerTop + containerHeight;
            // Active item is above the visible area (considering header offset)
            if (itemTop - headerOffset < containerTop) {
                container.scrollTo({
                    top: itemTop - headerOffset,
                    behavior: 'smooth'
                });
            }
            // Active item is below the visible area
            else if (itemBottom > containerBottom) {
                container.scrollTo({
                    top: itemBottom - containerHeight + headerOffset,
                    behavior: 'smooth'
                });
            }
        };
        _this.toggleSearchAndSuggested = function (toSuggested) {
            var _a, _b;
            var searchResults = _this.props.searchResults;
            var activeSelection = _this.state.activeSelection;
            var suggestedResults = _this.getCurrentSuggestedCodeList();
            var hasSearchResults = (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0;
            var hasSuggestedResults = ((_a = suggestedResults.caseList) === null || _a === void 0 ? void 0 : _a.length) > 0 ||
                ((_b = suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.encounterList) === null || _b === void 0 ? void 0 : _b.length) > 0;
            var hasActiveSelection = !!activeSelection; // Compact check for truthy value.
            if (toSuggested !== undefined) {
                if (toSuggested && hasSuggestedResults)
                    _this.updateSelection(ResultType.SUGGESTED_RESULTS);
                else if (!toSuggested && hasSearchResults)
                    _this.updateSelection(ResultType.SEARCH_RESULTS);
                return;
            }
            else {
                if (hasActiveSelection) {
                    if (activeSelection === ResultType.SEARCH_RESULTS &&
                        hasSuggestedResults)
                        _this.updateSelection(ResultType.SUGGESTED_RESULTS);
                    else if (activeSelection === ResultType.SUGGESTED_RESULTS &&
                        hasSearchResults)
                        _this.updateSelection(ResultType.SEARCH_RESULTS);
                }
                else {
                    if (hasSearchResults)
                        _this.updateSelection(ResultType.SEARCH_RESULTS);
                    else if (hasSuggestedResults)
                        _this.updateSelection(ResultType.SUGGESTED_RESULTS);
                }
            }
        };
        /**
         * Handles selection of the currently active item (when user presses Enter).
         *
         * Depending on the current active section (`SEARCH_RESULTS` or `SUGGESTED_RESULTS`),
         * it either triggers a search result selection or handles a suggested code selection.
         *
         * - For search results: directly calls `onSearchSelection`.
         * - For suggested results:
         *    - Calculates correct item position accounting for optional header buttons.
         *    - Finds and selects the correct code item.
         *    - If the code is already part of the current transaction and removal is allowed,
         *      triggers `onRemoveAllCodes`.
         *    - Otherwise, adds the selected code via `onSearchSelection`.
         *
         * After handling the selection, it resets the active state.
         */
        _this.applySelectedCode = function (event) {
            var _a;
            var _b = _this.state, activeIndex = _b.activeIndex, activeSelection = _b.activeSelection;
            var results = _this.props.searchResults;
            var suggestedResults = _this.getCurrentSuggestedCodeList();
            var allowHeaderButtons = _this.props.allowCodeRemove;
            var caseList = (suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.caseList) || [];
            var encounterList = (suggestedResults === null || suggestedResults === void 0 ? void 0 : suggestedResults.encounterList) || [];
            var currentOffset = 0;
            if (activeIndex !== -1) {
                // Selection is from search results
                if (activeSelection === ResultType.SEARCH_RESULTS) {
                    _this.props.onSearchSelection(results === null || results === void 0 ? void 0 : results[activeIndex]);
                }
                // Selection is from suggested results
                else if (activeSelection === ResultType.SUGGESTED_RESULTS) {
                    var activeItem_1 = null;
                    /**
                     * Finds the item in the given list based on the current activeIndex,
                     * adjusting for header buttons and previous list lengths.
                     */
                    var findItem = function (list) {
                        if (!list.length)
                            return false;
                        // If header buttons are rendered for this section, move the offset
                        if (allowHeaderButtons)
                            currentOffset += SUGGESTED_LIST_HEADER_BUTTONS_COUNT;
                        var indexInSection = activeIndex - currentOffset;
                        if (indexInSection >= 0 && indexInSection < list.length) {
                            activeItem_1 = list[indexInSection];
                            return true;
                        }
                        // Move the offset past this section
                        currentOffset += list.length;
                        return false;
                    };
                    // Try to find the selected item in either section
                    findItem(caseList.map(function (item) { return item.codeInfo; })) ||
                        findItem(encounterList.map(function (item) { return item.codeInfo; }));
                    if (activeItem_1) {
                        var transactionGuids = (_a = activeItem_1 === null || activeItem_1 === void 0 ? void 0 : activeItem_1.transaction_guids) !== null && _a !== void 0 ? _a : [];
                        // Check if the selected code is already part of the current transaction
                        var isInCurrentTnx = transactionGuids.includes(_this.props.transactionGuid);
                        if (isInCurrentTnx && allowHeaderButtons) {
                            // If it's already selected and removal is allowed, remove it
                            _this.props.onRemoveAllCodes([activeItem_1]);
                        }
                        else {
                            // Otherwise, select the code
                            _this.props.onSearchSelection(__assign({}, activeItem_1));
                        }
                    }
                }
            }
            _this.reset();
        };
        _this.handleSearchSelection = _this.handleSearchSelection.bind(_this);
        _this.getCurrentSuggestedCodeList = _this.getCurrentSuggestedCodeList.bind(_this);
        _this.getSuggestedRows = _this.getSuggestedRows.bind(_this);
        _this.moveFocus = _this.moveFocus.bind(_this);
        _this.applySelectedCode = _this.applySelectedCode.bind(_this);
        _this.updatePopupPosition = _this.updatePopupPosition.bind(_this);
        _this.updateSelection = _this.updateSelection.bind(_this);
        _this.toggleSearchAndSuggested = _this.toggleSearchAndSuggested.bind(_this);
        _this.handleSearchBarFocus = _this.handleSearchBarFocus.bind(_this);
        _this.handleSearchChange = _this.handleSearchChange.bind(_this);
        _this.onSubmit = _this.onSubmit.bind(_this);
        _this.handleKeyPress = _this.handleKeyPress.bind(_this);
        _this._detectClickOutside = _this._detectClickOutside.bind(_this);
        _this.handleFocusExit = _this.handleFocusExit.bind(_this);
        _this.handleOnInputFocus = _this.handleOnInputFocus.bind(_this);
        _this.handleAddAllCodes = _this.handleAddAllCodes.bind(_this);
        _this.handleRemoveAllCodes = _this.handleRemoveAllCodes.bind(_this);
        _this.getBulkOpCodes = _this.getBulkOpCodes.bind(_this);
        var WithResults = ((_a = _this.props.searchResults) === null || _a === void 0 ? void 0 : _a.length) > 0;
        _this.state = {
            active: WithResults,
            autocompleteEntry: ((_b = props.searchResults) === null || _b === void 0 ? void 0 : _b.length) ? 0 : -1,
            resultsActive: WithResults,
            showResults: WithResults,
            selecting: false,
            searching: false,
            codeQuery: {},
            searchResultPosition: 'bottom',
            resultHeight: 0,
            resultWidth: 0,
            searchBarContext: defaultSearchContext(),
            popupPosition: { top: 0, left: 0 },
            searchType: null,
            activeIndex: -1,
            activeSelection: null
        };
        _this.wrapperRef = react_1["default"].createRef();
        _this.resultRef = react_1["default"].createRef();
        _this.searchRef = react_1["default"].createRef();
        _this.searchResultsRef = react_1["default"].createRef();
        _this.suggestedResultsRef = react_1["default"].createRef();
        if (_this.props.autoBlur) {
            document.addEventListener('click', _this._detectClickOutside);
        }
        if (_this.props.debounceTimeout > 0) {
            var origSearch = _this.handleSearch.bind(_this);
            _this.handleSearch = ui_common_1.objectUtils.debounce(origSearch, _this.props.debounceTimeout);
        }
        return _this;
    }
    SuggestedLookup.prototype.componentDidMount = function () {
        window.addEventListener('scroll', this.updatePopupPosition, true);
        window.addEventListener('resize', this.updatePopupPosition);
        // Initial position update
        this.updatePopupPosition();
    };
    SuggestedLookup.prototype.componentWillUnmount = function () {
        window.removeEventListener('scroll', this.updatePopupPosition, true);
        window.removeEventListener('resize', this.updatePopupPosition);
    };
    /**
     * Calls onSearch.
     * @param codeQuery
     */
    SuggestedLookup.prototype.handleSearch = function (codeQuery) {
        var _a, _b;
        codeQuery.context = __assign(__assign({}, codeQuery.context), { meetsMinimum: ((_a = codeQuery === null || codeQuery === void 0 ? void 0 : codeQuery.text) === null || _a === void 0 ? void 0 : _a.length) > this.props.minLength });
        if (codeQuery.context.meetsMinimum) {
            this._setState({
                codeQuery: codeQuery,
                searching: true,
                showResults: ((_b = this.props.searchResults) === null || _b === void 0 ? void 0 : _b.length) > 0
            });
        }
        this.props.onSearch(codeQuery);
    };
    SuggestedLookup.prototype.scrollResultIfNeeded = function () {
        var _a;
        var activeResult = (_a = this.resultRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('.search-result-submittable');
        if (activeResult) {
            var visibility = (0, elements_1.isElementVisible)(activeResult, this.resultRef.current);
            if (!visibility.contained) {
                if (visibility.below) {
                    // only partial support for IE
                    // https://caniuse.com/scrollintoview
                    activeResult.scrollIntoView({
                        block: 'end',
                        behavior: 'smooth',
                        inline: 'nearest'
                    });
                }
                else {
                    activeResult.scrollIntoView({
                        block: 'start',
                        behavior: 'smooth',
                        inline: 'nearest'
                    });
                }
            }
        }
    };
    SuggestedLookup.prototype.handleOnInputFocus = function (searchType) {
        this.setState({
            searchType: searchType
        });
        this.updatePopupPosition();
    };
    SuggestedLookup.prototype.updateSelection = function (selection) {
        this.setState({ activeSelection: selection, activeIndex: 0 });
    };
    SuggestedLookup.prototype.reset = function () {
        if (this.searchRef) {
            this.searchRef.current.reset();
        }
        this.setState({
            resultsActive: false,
            showResults: false,
            selecting: false,
            searching: false,
            codeQuery: {},
            activeIndex: -1,
            activeSelection: null,
            searchType: null
        });
    };
    SuggestedLookup.prototype.focus = function () {
        if (this.searchRef.current) {
            this.searchRef.current.focus();
        }
    };
    SuggestedLookup.prototype._detectClickOutside = function (ev) {
        if (this.props.autoBlur) {
            var target = ev === null || ev === void 0 ? void 0 : ev.target;
            //Changed HTMLElement to Element because clicking on an SVG icon (e.g., the delete icon for codes) was not closing the current menu.
            if (target instanceof Element && this.wrapperRef.current !== null) {
                var outOfScope = !this.wrapperRef.current.contains(target);
                if (outOfScope) {
                    this._setState({
                        searching: false,
                        showResults: false,
                        active: false,
                        searchType: null,
                        popupPosition: null
                    });
                }
            }
        }
    };
    SuggestedLookup.prototype.handleFocusExit = function () {
        if (this.props.autoBlur) {
            this._setState({
                searching: false,
                showResults: false,
                active: false,
                searchType: null,
                popupPosition: null
            });
        }
    };
    SuggestedLookup.prototype.handleSearchChange = function (event) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
        if (((_a = this.state) === null || _a === void 0 ? void 0 : _a.searchType) === null ||
            this.state.searchType === undefined) {
            this.setState({ searchType: (_c = (_b = event === null || event === void 0 ? void 0 : event.detail) === null || _b === void 0 ? void 0 : _b.value) === null || _c === void 0 ? void 0 : _c.key });
        }
        if (this.props.autoSearch) {
            var evValues = (_d = event.detail.value) !== null && _d !== void 0 ? _d : { value: '', key: '' };
            var codeQuery = {
                text: evValues.value,
                searchType: evValues.key,
                searchResultsLookupKey: this.props.searchResultsLookupKey
            };
            if (((_f = (_e = event === null || event === void 0 ? void 0 : event.detail) === null || _e === void 0 ? void 0 : _e.value) === null || _f === void 0 ? void 0 : _f.eventSource) === 'dropdown') {
                codeQuery.text = '';
                this.state.codeQuery.text = '';
                this.searchRef.current.reset();
            }
            var showResults = (0, show_results_1.matchRequirements)(codeQuery);
            if (!showResults) {
                this._setState({
                    searching: false,
                    showResults: false,
                    active: true,
                    codeQuery: codeQuery,
                    searchBarContext: __assign(__assign({}, this.state.searchBarContext), { codeType: (_h = (_g = event === null || event === void 0 ? void 0 : event.detail) === null || _g === void 0 ? void 0 : _g.value) === null || _h === void 0 ? void 0 : _h.key })
                });
            }
            else if (showResults && !this.state.searching) {
                this._setState({
                    searching: true,
                    showResults: true,
                    active: true,
                    codeQuery: codeQuery,
                    searchBarContext: __assign(__assign({}, this.state.searchBarContext), { codeType: (_k = (_j = event === null || event === void 0 ? void 0 : event.detail) === null || _j === void 0 ? void 0 : _j.value) === null || _k === void 0 ? void 0 : _k.key })
                });
            }
            else {
                this._setState({
                    searching: true,
                    showResults: true,
                    active: true,
                    codeQuery: codeQuery,
                    searchBarContext: __assign(__assign({}, this.state.searchBarContext), { codeType: (_m = (_l = event === null || event === void 0 ? void 0 : event.detail) === null || _l === void 0 ? void 0 : _l.value) === null || _m === void 0 ? void 0 : _m.key })
                });
            }
            this.handleSearch(codeQuery);
        }
    };
    SuggestedLookup.prototype.onSubmit = function (event) {
        var _a;
        var evValues = (_a = event.detail.value) !== null && _a !== void 0 ? _a : { value: '', key: '' };
        var codeQuery = { text: evValues.value, searchType: evValues.key };
        this.handleSearch(codeQuery);
        if (!this.props.autoSearch) {
            this._setState({
                searching: true,
                showResults: true,
                active: true,
                codeQuery: codeQuery
            });
        }
    };
    SuggestedLookup.prototype.componentDidUpdate = function (prevProps, prevState) {
        var _a, _b, _c, _d, _e;
        var _f = this.props, searchResults = _f.searchResults, suggestedCodes = _f.suggestedCodes;
        var previousSearchResults = prevProps.searchResults, prevSuggestedCodes = prevProps.suggestedCodes;
        var _g = this.state, codeQuery = _g.codeQuery, searchType = _g.searchType;
        var prevSearchType = prevState.searchType;
        if (prevState.resultHeight !== this.state.resultHeight ||
            prevState.resultWidth !== this.state.resultWidth) {
            this.updatePopupPosition();
        }
        if (searchResults !== previousSearchResults ||
            suggestedCodes !== prevSuggestedCodes ||
            searchType !== prevSearchType) {
            // if a new result comes in we want to reset the scroll position
            // of the results so that it comes back to the top.
            var height = (_b = (_a = this.resultRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.height;
            var width = (_d = (_c = this.resultRef.current) === null || _c === void 0 ? void 0 : _c.getBoundingClientRect()) === null || _d === void 0 ? void 0 : _d.width;
            this._setState({
                resultHeight: height,
                resultWidth: width
            });
            if (this.state.showResults && this.resultRef.current) {
                this.resultRef.current.scrollTop = 0;
            }
            if (this.state.searching && ((_e = "".concat(codeQuery.text)) === null || _e === void 0 ? void 0 : _e.length) > 1) {
                this._setState({
                    searching: false,
                    showResults: true,
                    resultsActive: true
                });
            }
        }
    };
    SuggestedLookup.prototype._setState = function (s) {
        this.setState(function (state) {
            return __assign(__assign({}, state), s);
        });
    };
    SuggestedLookup.prototype.handleSearchBarFocus = function (ev) {
        var _this = this;
        if (!this.state.active) {
            // The focus event fires after the SearchBar change event, but
            // in the same thread afaict.
            // What this means in practice is that calls to get and set
            // state can have unwanted effects.  Since React's setState queues
            // changes, the desired changes can be overridden if they happen
            // in succession.  By running the call in the next `tick`, then
            // the changes that we're looking for, do not get clobbered.
            setTimeout(function () {
                var showResults = Array.isArray(_this.props.searchResults);
                _this._setState({ showResults: showResults, active: true });
            }, 0);
        }
    };
    SuggestedLookup.prototype.handleSearchSelection = function (ev, codeInfo, opType) {
        var _a;
        ev.preventDefault();
        if (!!codeInfo) {
            var searchSelection = this.props.getSelectionData(codeInfo);
            if (opType === 'delete') {
                this.props.onRemoveAllCodes([searchSelection]);
            }
            else {
                this.props.onSearchSelection(searchSelection);
            }
            this.searchRef.current.reset();
            this._setState({
                active: false,
                showResults: false,
                selecting: false,
                searching: false,
                codeQuery: {
                    text: ''
                },
                activeIndex: 0,
                activeSelection: null
            });
            var textInput = (_a = this.wrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelector('input.form-input');
            if (textInput) {
                textInput.focus();
            }
        }
    };
    SuggestedLookup.prototype.getCurrentSuggestedCodeList = function () {
        var _a, _b;
        var searchType = this.state.searchType;
        var suggestedCodes = this.props.suggestedCodes;
        var suggestedList = searchType === CodeType.CPT
            ? suggestedCodes === null || suggestedCodes === void 0 ? void 0 : suggestedCodes.cpt
            : searchType === CodeType.ICD
                ? suggestedCodes === null || suggestedCodes === void 0 ? void 0 : suggestedCodes.diagnosis
                : searchType === CodeType.MODIFIER
                    ? suggestedCodes === null || suggestedCodes === void 0 ? void 0 : suggestedCodes.modifier
                    : {
                        encounterList: [],
                        caseList: []
                    };
        var mapList = function (codelist) {
            return Array.isArray(codelist)
                ? codelist === null || codelist === void 0 ? void 0 : codelist.map(function (codeInfo) { return ({
                    codeInfo: codeInfo,
                    searchType: searchType
                }); })
                : [];
        };
        return {
            encounterList: mapList((_a = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.encounterList) !== null && _a !== void 0 ? _a : []),
            caseList: mapList((_b = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.caseList) !== null && _b !== void 0 ? _b : [])
        };
    };
    SuggestedLookup.prototype.getBulkOpCodes = function (opType) {
        var _a;
        var suggestedMap = this.getCurrentSuggestedCodeList();
        var suggestedList = opType === SugggestedCodeType.CURRENT_CASE
            ? suggestedMap === null || suggestedMap === void 0 ? void 0 : suggestedMap.caseList
            : suggestedMap === null || suggestedMap === void 0 ? void 0 : suggestedMap.encounterList;
        var codeList = (_a = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.map(function (item) { return item.codeInfo; })) !== null && _a !== void 0 ? _a : [];
        return codeList;
    };
    SuggestedLookup.prototype.handleAddAllCodes = function (event, opType) {
        event.preventDefault();
        var codeList = this.getBulkOpCodes(opType);
        console.log(codeList);
        this.props.onAddAllCodes(codeList);
    };
    SuggestedLookup.prototype.handleRemoveAllCodes = function (event, opType) {
        event.preventDefault();
        var codeList = this.getBulkOpCodes(opType);
        console.log(codeList);
        this.props.onRemoveAllCodes(codeList);
    };
    SuggestedLookup.prototype.getSuggestedRows = function (suggestedList, suggestedListType, indexOffset) {
        var _this = this;
        var _a, _b;
        var suggestedResults;
        var headerLabel = suggestedListType === SugggestedCodeType.CURRENT_CASE
            ? 'In this case'
            : 'In this encounter';
        var sectionStartIndex = indexOffset;
        var selectAllName = suggestedListType === SugggestedCodeType.CURRENT_CASE
            ? 'caseList'
            : 'encounterList';
        suggestedResults = suggestedList === null || suggestedList === void 0 ? void 0 : suggestedList.map(function (result, idx) {
            var _a, _b, _c, _d;
            return ((0, jsx_runtime_1.jsx)(result_row_1.ResultRow, { activeIdx: (_a = _this.state) === null || _a === void 0 ? void 0 : _a.activeIndex, activeSelection: (_b = _this.state) === null || _b === void 0 ? void 0 : _b.activeSelection, codeInfo: result === null || result === void 0 ? void 0 : result.codeInfo, idx: idx +
                    sectionStartIndex +
                    (_this.props.allowCodeRemove ? SUGGESTED_LIST_HEADER_BUTTONS_COUNT : 0), allowCodeRemove: (_c = _this.props) === null || _c === void 0 ? void 0 : _c.allowCodeRemove, transactionGuid: (_d = _this.props) === null || _d === void 0 ? void 0 : _d.transactionGuid, isSuggestedRow: true, handleClick: _this.handleSearchSelection }));
        });
        if (!ui_common_1.objectUtils.isEmpty(suggestedResults)) {
            suggestedResults.unshift((0, jsx_runtime_1.jsx)(result_row_1.ResultHeaderRow, { label: headerLabel, isSuggestedRow: true, allowCodeRemove: (_a = this.props) === null || _a === void 0 ? void 0 : _a.allowCodeRemove, name: "selectall_".concat(selectAllName, "_").concat((_b = this.props) === null || _b === void 0 ? void 0 : _b.transactionGuid), opType: suggestedListType, handleSelectAll: this.handleAddAllCodes, handleUnselectAll: this.handleRemoveAllCodes, activeIndex: this.state.activeIndex, sectionStartIndex: sectionStartIndex, activeSelection: this.state.activeSelection }));
        }
        return suggestedResults;
    };
    SuggestedLookup.prototype.render = function () {
        var _this = this;
        var _a, _b, _c, _d, _e;
        var _f = this.props, onSearch = _f.onSearch, searchResults = _f.searchResults, onSearchSelection = _f.onSearchSelection, autoFocus = _f.autoFocus, autoBlur = _f.autoBlur, shouldShowResults = _f.shouldShowResults, FieldDefinitions = _f.FieldDefinitions, placeholderText = _f.placeholderText, actionPrefix = _f.actionPrefix, autoSearch = _f.autoSearch, getSelectionData = _f.getSelectionData, debounceTimeout = _f.debounceTimeout, showSearchButton = _f.showSearchButton, actionNameForDD = _f.actionNameForDD, suggestedCodes = _f.suggestedCodes, rest = __rest(_f, ["onSearch", "searchResults", "onSearchSelection", "autoFocus", "autoBlur", "shouldShowResults", "FieldDefinitions", "placeholderText", "actionPrefix", "autoSearch", "getSelectionData", "debounceTimeout", "showSearchButton", "actionNameForDD", "suggestedCodes"]);
        var state = this.state;
        var showResults = shouldShowResults(state);
        var styleClasses = [
            'suggested-lookupV2',
            {
                'is-active': this.state.active,
                'is-searching': this.state.searching,
                'is-selecting': this.state.selecting,
                'show-results': showResults,
                'has-search-results': showResults && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0
            }
        ];
        var results;
        if (showResults && (searchResults === null || searchResults === void 0 ? void 0 : searchResults.length) > 0) {
            results = searchResults === null || searchResults === void 0 ? void 0 : searchResults.map(function (result, idx) {
                var _a, _b;
                return ((0, jsx_runtime_1.jsx)(result_row_1.ResultRow, { activeIdx: (_a = _this.state) === null || _a === void 0 ? void 0 : _a.activeIndex, activeSelection: (_b = _this.state) === null || _b === void 0 ? void 0 : _b.activeSelection, codeInfo: result, idx: idx, handleClick: _this.handleSearchSelection }));
            });
            if (!ui_common_1.objectUtils.isEmpty((_a = this.state.codeQuery) === null || _a === void 0 ? void 0 : _a.text)) {
                results.unshift((0, jsx_runtime_1.jsx)(result_row_1.ResultHeaderRow, { label: "Result for \u201C".concat((_b = this.state.codeQuery) === null || _b === void 0 ? void 0 : _b.text, "\u201D"), name: "searchResult_".concat(this.props.transactionGuid), activeIndex: this.state.activeIndex, activeSelection: this.state.activeSelection }));
            }
        }
        else if (state.searching) {
            results = placeholderResult('Searching...', FieldDefinitions);
        }
        else if (showResults) {
            results = placeholderResult("No results found for '".concat((_d = (_c = this.state.codeQuery) === null || _c === void 0 ? void 0 : _c.text) !== null && _d !== void 0 ? _d : '', "'"), FieldDefinitions);
        }
        var suggestedCodeList = this.getCurrentSuggestedCodeList();
        var caseRows = this.getSuggestedRows(suggestedCodeList === null || suggestedCodeList === void 0 ? void 0 : suggestedCodeList.caseList, SugggestedCodeType.CURRENT_CASE, 0);
        var encounterRows = this.getSuggestedRows(suggestedCodeList === null || suggestedCodeList === void 0 ? void 0 : suggestedCodeList.encounterList, SugggestedCodeType.RELATED_CASE, ((_e = suggestedCodeList === null || suggestedCodeList === void 0 ? void 0 : suggestedCodeList.caseList) === null || _e === void 0 ? void 0 : _e.length)
            ? suggestedCodeList.caseList.length +
                SUGGESTED_LIST_HEADER_BUTTONS_COUNT
            : 0);
        return ((0, jsx_runtime_1.jsxs)("div", __assign({}, rest, { onKeyDown: suppressEnterKey, onFocus: this.handleSearchBarFocus, ref: this.wrapperRef, className: (0, classnames_1["default"])(styleClasses) }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "search-cols" }, { children: (0, jsx_runtime_1.jsx)(ui_components_1.SearchBar, { ref: this.searchRef, flex: true, disabled: this.props.disabled, actionPrefix: this.props.actionPrefix, autoFocus: autoFocus, onKeyPress: this.handleKeyPress, onChange: this.handleSearchChange, onFocus: this.handleOnInputFocus, onSubmit: this.onSubmit, FieldDefinitions: FieldDefinitions, placeholder: this.props.placeholderText, showSearchButton: this.props.showSearchButton, actionNameForDD: this.props.actionNameForDD, searchBarViewVersion: this.props.SearchBarViewVersion }) })), this.state.popupPosition && ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "result-container", ref: this.resultRef, style: {
                        top: "".concat(this.state.popupPosition.top, "px"),
                        left: "".concat(this.state.popupPosition.left, "px") // Dynamic position
                    } }, { children: [(0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ on: !ui_common_1.objectUtils.isEmpty(results), style: { minWidth: '50%' } }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "search-results", ref: this.searchResultsRef }, { children: results })) })), (0, jsx_runtime_1.jsx)(conditional_1.Conditional, __assign({ some: [
                                !ui_common_1.objectUtils.isEmpty(caseRows),
                                !ui_common_1.objectUtils.isEmpty(encounterRows)
                            ], style: { minWidth: '50%' } }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ className: "suggested-results search-results", ref: this.suggestedResultsRef }, { children: [caseRows, encounterRows] })) }))] })))] })));
    };
    SuggestedLookup.displayName = 'Suggested Lookup';
    SuggestedLookup.defaultProps = {
        autoFocus: false,
        autoBlur: true,
        autoSearch: true,
        actionPrefix: 'Add',
        debounceTimeout: 0,
        placeholderText: 'Search for code',
        minLength: 2,
        FieldDefinitions: [],
        showSearchButton: true,
        actionNameForDD: '~Focus code search',
        searchBarViewVersion: 'SearchBarView1',
        allowCodeRemove: false,
        transactionGuid: '',
        getSelectionData: getSelectionData,
        shouldShowResults: function (codeQuery) { return true; },
        onSearchSelection: function (searchSelection) { },
        onSearch: function (codeQuery) { },
        searchBarContext: defaultSearchContext,
        onAddAllCodes: function (codes) { },
        onRemoveAllCodes: function (codes) { }
    };
    return SuggestedLookup;
}(react_1["default"].Component));
exports.SuggestedLookup = SuggestedLookup;
//# sourceMappingURL=lookupV2.js.map